import { Component, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

/**
 * Editor for a node's `requiredMetadata` — the list of metadata keys the node
 * needs at execution time. Emits the full updated list on every change.
 */
@Component({
  selector: 'app-required-metadata-editor',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './required-metadata-editor.component.html',
  styleUrl: './required-metadata-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequiredMetadataEditorComponent {
  readonly items = input<string[]>([]);
  readonly itemsChange = output<string[]>();

  readonly draft = signal('');

  add(): void {
    const key = this.draft().trim();
    if (!key || this.items().includes(key)) return;
    this.itemsChange.emit([...this.items(), key]);
    this.draft.set('');
  }

  remove(key: string): void {
    this.itemsChange.emit(this.items().filter(k => k !== key));
  }
}
